// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-design[data-v-9a3f9ede] {
  height: 420px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.report-design .btns[data-v-9a3f9ede] {
  margin-bottom: 12px;
}
.report-design .right[data-v-9a3f9ede] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/DataAnalysis/ReportDesign.vue","webpack://./ReportDesign.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ACAF;ADLA;EAOI,mBAAA;ACCJ;ADRA;EAUI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;ACCJ","sourcesContent":["\n.report-design {\n  height: 420px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  .btns {\n    margin-bottom: 12px;\n  }\n  .right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    gap: 12px;\n  }\n}\n",".report-design {\n  height: 420px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.report-design .btns {\n  margin-bottom: 12px;\n}\n.report-design .right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
